"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = void 0;
const checkout = __importStar(require("@imtbl/checkout-sdk"));
const config = __importStar(require("@imtbl/config"));
const ZKEVM_NATIVE_TOKEN = {
    name: "IMX",
    symbol: "IMX",
    decimals: 18,
    address: "native",
};
const DEV_CHAIN_ID_NETWORK_MAP = new Map([
    [
        checkout.ChainId.SEPOLIA,
        {
            chainIdHex: `0x${checkout.ChainId.SEPOLIA.toString(16)}`,
            chainName: checkout.ChainName.SEPOLIA,
            rpcUrls: ["https://checkout-api.dev.immutable.com/v1/rpc/eth-sepolia"],
            nativeCurrency: {
                name: "Sep Eth",
                symbol: "ETH",
                decimals: 18,
            },
            blockExplorerUrls: ["https://sepolia.etherscan.io/"],
        },
    ],
    [
        checkout.ChainId.IMTBL_ZKEVM_DEVNET,
        {
            chainIdHex: `0x${checkout.ChainId.IMTBL_ZKEVM_DEVNET.toString(16)}`,
            chainName: checkout.ChainName.IMTBL_ZKEVM_DEVNET,
            rpcUrls: ["https://rpc.dev.immutable.com"],
            nativeCurrency: ZKEVM_NATIVE_TOKEN,
        },
    ],
]);
const overrides = () => ({
    baseUrl: "https://api.dev.immutable.com",
    chainSlug: checkout.ChainSlug.IMTBL_ZKEVM_DEVNET,
    l2ChainId: checkout.ChainId.IMTBL_ZKEVM_DEVNET,
    networkMap: DEV_CHAIN_ID_NETWORK_MAP,
    remoteConfigEndpoint: "https://checkout-api.dev.immutable.com",
});
exports.overrides = overrides;
// Test
() => new checkout.Checkout({
    baseConfig: new config.ImmutableConfiguration({
        environment: config.Environment.SANDBOX,
    }),
    overrides: (0, exports.overrides)(),
});
